import React, { useState } from 'react';
import ShippingStep from './ShippingStep';
import PaymentStep  from './PaymentStep';

/* ============================================================
   CHECKOUT FLOW MOCK — Club Huella
   
   Orquesta los dos pasos del checkout con un artículo de prueba:
     1. ShippingStep → cotiza envío (real, contra clubhuella.com) → onNext(shippingData)
     2. PaymentStep  → arma el body y redirige a Mercado Pago (real)

   El "mock" es únicamente el producto (data + generated). Las llamadas
   de cotización (RATE_URL) y pago (PAY_URL) que hacen los hijos son reales.

   Uso:
     import CheckoutFlowMock from './CheckoutFlowMock';
     <CheckoutFlowMock />
   ============================================================ */

/* ── Artículo mock ─────────────────────────────────────────── */
/* style debe ser una key de STYLES_MAP: vogue | retro | streetwear |
   college | collage | minimal | anime | rap-tee
   color debe ser una key de COLORS_MAP: blanca | negra            */
const MOCK_DATA = {
  style: 'vogue',
  name:  'Firulais',
  color: 'negra',
  size:  'M',
  photo: null,
};

/* generated = lo que devolvería tu API tras generar el diseño.
   resolveDesignSrc() en PaymentStep antepone https://clubhuella.com/
   a imagen_url salvo que empiece con "data:". Acá usamos un data URI
   para que el thumbnail del resumen se vea sin depender del backend.  */
const MOCK_GENERATED = {
  id:             'mock-design-001',
  imagen_url:     'disenos/mock-firulais.png',
  imagen_generada:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='%23171717'/%3E%3Ccircle cx='32' cy='42' r='11' fill='%23fff'/%3E%3Ccircle cx='20' cy='24' r='5' fill='%23fff'/%3E%3Ccircle cx='44' cy='24' r='5' fill='%23fff'/%3E%3Ccircle cx='12' cy='35' r='4' fill='%23fff'/%3E%3Ccircle cx='52' cy='35' r='4' fill='%23fff'/%3E%3C/svg%3E",
};

const STEPS = { SHIPPING: 'shipping', PAYMENT: 'payment' };

export default function CheckoutFlowMock() {
  const [step, setStep]                 = useState(STEPS.SHIPPING);
  const [shippingData, setShippingData] = useState(null);

  /* ShippingStep.onNext → recibimos el shippingData y avanzamos a pago */
  const handleShippingNext = (data) => {
    setShippingData(data);
    setStep(STEPS.PAYMENT);
  };

  /* PaymentStep.onBack → volver al envío */
  const handleBackToShipping = () => setStep(STEPS.SHIPPING);

  /* ShippingStep.onBack → en el flujo real volvería al ResultStep (diseño).
     En este mock no hay paso previo, así que lo dejamos como no-op. */
  const handleBackToDesign = () => {
    console.log('[CheckoutFlowMock] onBack desde ShippingStep — sin paso previo en el mock');
  };

  return (
    <div className="relative bg-white">
      {step === STEPS.SHIPPING && (
        <ShippingStep
          data={MOCK_DATA}
          generated={MOCK_GENERATED}
          onNext={handleShippingNext}
          onBack={handleBackToDesign}
        />
      )}

      {step === STEPS.PAYMENT && shippingData && (
        <PaymentStep
          data={MOCK_DATA}
          generated={MOCK_GENERATED}
          shippingData={shippingData}
          onBack={handleBackToShipping}
        />
      )}
    </div>
  );
}

export { MOCK_DATA, MOCK_GENERATED };